import { arc } from "d3"
import { Component, Input, OnChanges } from '@angular/core';
import { ArcData } from "../../store/reselectors/budget.data";
import { CommonModule } from "@angular/common";

window['arc'] = arc
const drawArcGenerator = (iRad, oRad, startPercent, endPercent) => 
  (arc as any)().innerRadius(iRad).outerRadius(oRad).startAngle(Math.PI*2*startPercent).endAngle(Math.PI*2*endPercent)



@Component({
    selector: 'arc',
    template: `
<svg *ngIf="dim/2 as half" [attr.width]="dim + 60" [attr.height]="dim" >
  <g [attr.transform]="'translate(' + (half + 30) + ',' + half + ')'">
    <path *ngFor="let data of arcData; index as i"
      [attr.fill]="data.color"
      [attr.d]="arcPaths[i]"
    ></path>
  </g>
  <g [attr.transform]="'translate(' + (half + 30) + ',' + half + ')'">
    <text *ngFor="let data of arcData; index as i" [attr.x]="centroids[i][0]" [attr.y]="centroids[i][1]"
      [attr.text-anchor]="centroids[i][0] > 0 ? 'start' : 'end'" alignment-baseline="central" style="font-size: 14px; fill: #41474f;">
      {{ data.label }}
    </text>
  </g>
</svg>
`,
    styles: [`
    svg { overflow: visible; }
  `],
    standalone: true,
    imports: [CommonModule],
})

export class ArcComponent implements OnChanges {
  @Input() dim = 240
  @Input() offsetPercent = 0.05
  @Input() arcData: ArcData[] = []
  arcPaths: string[] = []
  centroids: number[][] = []
/* 
  const arcFunction = drawArcGenerator(0, this.dim/2, d.startPercent, d.endPercent)
  this.arcPaths.push(arcFunction())
  const centroid = arcFunction.centroid()
  let y = centroid[1]
  let modifier = 0 */

  getSVGs() {

    // console.log("ARC DATA", this.arcData)
    this.arcPaths = []
    this.centroids = []
    const radius = this.dim/2 - 20
    let lastAngle = -30 / 360

    this.arcData.forEach(d => {
      const startPercent = d.startPercent + this.offsetPercent
      const endPercent = d.endPercent + this.offsetPercent
      const arcFunction = drawArcGenerator(0, radius, startPercent, endPercent)
      this.arcPaths.push(arcFunction())
      
      lastAngle = Math.max(endPercent - (endPercent - startPercent) / 2, lastAngle + 30 / 360)
      const centroid = drawArcGenerator(radius, this.dim/2, lastAngle, lastAngle).centroid()
      this.centroids.push(centroid)
    })
    // console.log({ arcPaths: this.arcPaths, centroids: this.centroids }) 
  }

  ngOnInit() {
    this.getSVGs()
  }

  ngOnChanges() {
    this.getSVGs()
  }

}
